import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';
import { defaultFilters } from '../carousels.utils';
import { GenericCarousel } from './generic-carousel';

export function TopSellersCarousel(props) {
  const flags = useFlags();
  const isProductCardsV2Enabled = flags['growth.ecomm.product-card-v2.rollout'] ?? false;

  const { loading, products } = useDispensaryProducts({
    filters: {
      ...defaultFilters,
      sortBy: `popular`,
      useCache: true,
    },
    perPage: 25,
  });

  const title = `Top Sellers`;

  if (!products?.length && !loading) {
    return null;
  }

  if (isProductCardsV2Enabled) {
    return (
      <ProductCarousel
        products={products}
        isLoading={loading}
        hideTitle={props?.showTitle === false}
        hideLink={props?.showLink === false}
        title={title}
        isSmallTitle={props?.isSmallTitle}
        alwaysUseSmallCards={props?.alwaysUseSmallCards}
      />
    );
  }

  const sectionProps = {
    ...props,
    isLoading: loading,
    label: title,
    products,
  };

  return <GenericCarousel {...sectionProps} />;
}
